function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Emojis",
    clipPath: "url(#clip0_629_5386)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5636 13.9416C10.5625 7.125 12.8542 2.54167 17.4375 0.25C18.0104 7.125 24.3125 9.41667 24.3125 17.4375C24.3125 20.1725 23.226 22.7956 21.292 24.7295C19.3581 26.6635 16.735 27.75 14 27.75C11.265 27.75 8.64193 26.6635 6.70796 24.7295C4.77399 22.7956 3.6875 20.1725 3.6875 17.4375C3.6875 13.4271 4.83333 11.7083 7.125 9.41667C7.125 12.8542 10.5636 13.9416 10.5636 13.9416Z",
    fill: "#BEA1FF",
    style: {
      fill: "#BEA1FF",
      fill: "color(display-p3 0.7451 0.6314 1.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.1,
    d: "M14 27.4636C9.38688 27.4636 5.48073 24.4661 4.10229 20.3159C5.34896 24.6094 9.30438 27.7501 14 27.7501C18.6956 27.7501 22.651 24.6094 23.8977 20.3159C22.5193 24.4661 18.6131 27.4636 14 27.4636Z",
    fill: "#010101",
    style: {
      fill: "#010101",
      fill: "color(display-p3 0.0039 0.0039 0.0039)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.1562 20.3019C19.1562 21.6694 18.613 22.981 17.646 23.9479C16.679 24.9149 15.3675 25.4582 14 25.4582C12.6325 25.4582 11.321 24.9149 10.354 23.9479C9.387 22.981 8.84375 21.6694 8.84375 20.3019C8.84375 18.3804 9.41667 17.3892 10.5625 16.2915C10.5625 18.5832 12.2812 19.1561 12.2812 19.1561C12.2812 15.8905 13.4271 13.9517 15.7187 12.854C16.0052 16.1483 19.1562 17.2231 19.1562 20.3019Z",
    fill: "#60439E",
    style: {
      fill: "#60439E",
      fill: "color(display-p3 0.3765 0.2627 0.6196)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.2,
    d: "M12.2812 19.4425C12.2812 16.1769 13.4271 14.2382 15.7187 13.1405C15.9995 16.3694 19.0256 17.4706 19.1448 20.4131C19.1459 20.3753 19.1562 20.3397 19.1562 20.3019C19.1562 17.2219 16.0052 16.1483 15.7187 12.854C13.4271 13.9517 12.2812 15.8905 12.2812 19.1561C12.2812 19.1561 10.5625 18.5832 10.5625 16.2915C9.41667 17.3892 8.84375 18.3804 8.84375 20.3019C8.84375 20.3294 8.85177 20.3546 8.85177 20.3821C8.89417 18.6004 9.45906 17.6344 10.5625 16.578C10.5625 18.8696 12.2812 19.4425 12.2812 19.4425Z",
    fill: "#F0E4FF",
    style: {
      fill: "#F0E4FF",
      fill: "color(display-p3 0.9412 0.8941 1.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.1,
    d: "M14 25.1717C12.6473 25.171 11.3492 24.6382 10.3859 23.6885C9.42267 22.7388 8.87163 21.4483 8.85177 20.0957C8.85062 20.1667 8.84375 20.2286 8.84375 20.302C8.84375 21.6695 9.387 22.981 10.354 23.948C11.321 24.915 12.6325 25.4582 14 25.4582C15.3675 25.4582 16.679 24.915 17.646 23.948C18.613 22.981 19.1562 21.6695 19.1562 20.302C19.1562 20.2412 19.1471 20.1862 19.1448 20.1266C19.1175 21.4734 18.5636 22.7558 17.6018 23.699C16.6401 24.6421 15.347 25.1708 14 25.1717Z",
    fill: "#010101",
    style: {
      fill: "#010101",
      fill: "color(display-p3 0.0039 0.0039 0.0039)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    opacity: 0.2,
    d: "M10.5636 14.228C10.5625 7.41146 12.8542 2.82812 17.4375 0.536458C18.007 7.36792 24.2266 9.68021 24.3056 17.5784C24.3056 17.5315 24.3125 17.4856 24.3125 17.4375C24.3125 9.41667 18.0104 7.125 17.4375 0.25C12.8542 2.54167 10.5625 7.125 10.5636 13.9416C10.5636 13.9416 7.125 12.8542 7.125 9.41667C4.83333 11.7083 3.6875 13.4271 3.6875 17.4375C3.6875 17.4787 3.69323 17.52 3.69323 17.5612C3.7276 13.6734 4.86771 11.9604 7.125 9.70312C7.125 13.1406 10.5636 14.228 10.5636 14.228Z",
    fill: "#F0E4FF",
    style: {
      fill: "#F0E4FF",
      fill: "color(display-p3 0.9412 0.8941 1.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M10.5636 13.9416C10.5625 7.125 12.8542 2.54167 17.4375 0.25C18.0104 7.125 24.3125 9.41667 24.3125 17.4375C24.3125 20.1725 23.226 22.7956 21.292 24.7295C19.3581 26.6635 16.735 27.75 14 27.75C11.265 27.75 8.64193 26.6635 6.70796 24.7295C4.77399 22.7956 3.6875 20.1725 3.6875 17.4375C3.6875 13.4271 4.83333 11.7083 7.125 9.41667C7.125 12.8542 10.5636 13.9416 10.5636 13.9416Z",
    fill: "url(#paint0_linear_629_5386)",
    style: {}
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_629_5386",
    x1: 5.87146,
    y1: 9.9426,
    x2: 24.7674,
    y2: 18.7541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2,
    style: {
      stopColor: "white",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_629_5386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.5,
    height: 27.5,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(0.25 0.25)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrending);
export default __webpack_public_path__ + "static/media/trending.76ae5fb4c602a1fd4a52ca01f41ab23d.svg";
export { ForwardRef as ReactComponent };